import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["container"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useIsomorphicLayoutEffect } from '@cian/react-utils';
import * as React from 'react';
import { createPortal } from 'react-dom';
import { DomPrimitive } from '../DomPrimitive';
import { jsx as _jsx } from "react/jsx-runtime";
var PORTAL_NAME = 'Portal';
export var Portal = /*#__PURE__*/React.forwardRef(function (props, forwardedRef) {
  var _globalThis$document;
  var containerProp = props.container,
    portalProps = _objectWithoutProperties(props, _excluded);
  var _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    mounted = _React$useState2[0],
    setMounted = _React$useState2[1];
  useIsomorphicLayoutEffect(function () {
    return setMounted(true);
  }, []);
  var container = containerProp || mounted && (globalThis === null || globalThis === void 0 || (_globalThis$document = globalThis.document) === null || _globalThis$document === void 0 ? void 0 : _globalThis$document.body);
  return container ? /*#__PURE__*/createPortal( /*#__PURE__*/_jsx(DomPrimitive.div, _objectSpread(_objectSpread({}, portalProps), {}, {
    ref: forwardedRef
  })), container) : null;
});
Portal.displayName = PORTAL_NAME;